import { render, staticRenderFns } from "./wageBatchInfoGroupTable.vue?vue&type=template&id=47ec17a5&scoped=true&"
import script from "./wageBatchInfoGroupTable.vue?vue&type=script&lang=js&"
export * from "./wageBatchInfoGroupTable.vue?vue&type=script&lang=js&"
import style0 from "./wageBatchInfoGroupTable.vue?vue&type=style&index=0&id=47ec17a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ec17a5",
  null
  
)

export default component.exports